/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PremierService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @param filename 
     * @returns any Success
     * @throws ApiError
     */
    public getApiPremierXml(
filename: string,
): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Premier/{filename}.xml',
            path: {
                'filename': filename,
            },
        });
    }

}
